// Trustpilot brand star fill colors keyed by rating band
export const getStarFillColor = (rating: number): string => {
  if (rating >= 4.5) return '#00b67a'; // Excellent
  if (rating >= 3.5) return '#73cf11'; // Great
  if (rating >= 2.5) return '#ffce00'; // Average
  if (rating >= 1.5) return '#ff8622'; // Poor
  return '#ff3722'; // Bad
};

export const getRatingLabel = (
  trustScore: number,
  getDictionaryValue: (key: string) => string
): string => {
  if (trustScore >= 4.5) return getDictionaryValue('TP_Excellent');
  if (trustScore >= 3.5) return getDictionaryValue('TP_Great');
  if (trustScore >= 2.5) return getDictionaryValue('TP_Average');
  if (trustScore >= 1.5) return getDictionaryValue('TP_Poor');
  return getDictionaryValue('TP_Bad');
};
